import Vue from "vue";
import errorHandler from "@/utils/errorHandler";
import { objectToForm } from "@/utils";

function transformer({ pdf, xml }, motive, date, id_) {
  return objectToForm({
    pdf_file: pdf,
    xml_file: xml,
    comment: motive,
    cancellation_date: date,
    id: id_,
  });
}

export default (taxReceipt, cancellationFile, motive, date) => {
  // cancellation does not check? tax receipt
  const payload = transformer(cancellationFile, motive, date, taxReceipt.id);
  return errorHandler(
    Vue.$http.post("taxreceipt/cancellation/", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
};



// WEBPACK FOOTER //
// ./src/services/taxReceipt/cancelTaxReceipt.js